import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BackButton, CustomButton, InputImageFieldGrid, InputSelectFieldGrid, InputTextFieldGrid } from "components";
import { useState } from "react";
import { getCuentasComercioPadreService } from "services/abonos/abonosService";

const AbonoForm = ({ title, goBack, submit }) => {
  const { control, handleSubmit } = useForm();
  const [accounts, setAccounts] = useState([]);
  useEffect(() => {
    getCuentasComercioPadreService()
      .then((result) => setAccounts(result))
      .catch((error) => console.error(error));
  }, []);

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" >
        <div>
          <BackButton click={goBack} />
        </div>
        <div className='container-title'>
          <div className='title'>{title}</div>
        </div>
        <div>
          <div style={{ width: "170px" }}></div>
        </div>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" mt={"40px"}>
        <Grid width={"70%"} container spacing={3}>
          <InputTextFieldGrid
            label={"Banco Origen"}
            xs={6}
            name={"bankOrigin"}
            required={"Debes agregar el banco origen"}
            control={control}
          />
          <InputSelectFieldGrid
            label={"Banco Destino"}
            xs={6}
            name={"bankDestination"}
            required={"Debes seleccionar una cuenta destino"}
            control={control}
            data={accounts.map((account) => ({
              id: account.id,
              name: `${account.bank} - ${account.accountNumber || account.clabe}`,
            }))}
          />

          <InputTextFieldGrid
            label={"Importe"}
            name={"amount"}
            required={"Debes agregar el importe"}
            inputType={"number"}
            step={"any"}
            control={control}
            rules={{
              validate: (value) => parseFloat(value) > 0 || "El valor debe ser mayor a 0",
            }}
          />
          <InputSelectFieldGrid
            label={"Bolsa destino"}
            name={"bagType"}
            required={"Debes seleccionar la bolsa destino"}
            control={control}
            data={[
              { id: "TAE", name: "TAE" },
              { id: "PDS", name: "PDS" },
            ]}
          />
          <InputImageFieldGrid
            name={"receipt"}
            control={control}
            label={"Recibo"}
            required={"Debes agregar el recibo"}
          />
          <InputTextFieldGrid
            label={"Referencia"}
            name={"reference"}
            required={"Debes agregar la referencia"}
            control={control}
            xs={6}
          />

          <InputTextFieldGrid
            xs={6}
            label={"Fecha depósito"}
            name={"date"}
            required={"Debes agregar la fecha"}
            inputType={"datetime-local"}
            control={control}
          />
          <Grid container justifyContent="center" mt={5}>
            <CustomButton click={handleSubmit(submit)} name={"Guardar"} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AbonoForm;
